import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    loading: false,
    success: false,
    error: null,
    hasSubscription: false,
  },
  reducers: {
    updatePasswordRequest: (state) => {
      state.loading = true;
      state.success = false;
      state.error = null;
    },
    updatePasswordSuccess: (state) => {
      state.loading = false;
      state.success = true;
    },
    updatePasswordFail: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetUserState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    },
    setValidateSubscription: (state, action) => {
      state.hasSubscription = action.payload;
    },
  },
});

export const {
  updatePasswordRequest,
  updatePasswordSuccess,
  updatePasswordFail,
  resetUserState,
  setValidateSubscription,
} = userSlice.actions;
export default userSlice.reducer;
